<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          {{ action }} Report Definition
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field v-if="!isCopy">
              <b-checkbox v-model="localForm.is_tabular_report">
                Tabular Report Definition
              </b-checkbox>
            </b-field>
            <b-field label="Country">
              <b-select
                expanded
                name="country"
                v-model="localForm.country"
                v-on:input="filterScheme"
                placeholder="Please select"
                :disabled="viewOnly"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                  selected
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Scheme">
              <b-select
                expanded
                name="scheme"
                v-model="localForm.scheme"
                v-on:input="filterStream"
                :disabled="viewOnly"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in schemes"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Stream">
              <b-select
                expanded
                name="stream"
                v-model="localForm.stream"
                placeholder="Please select"
                :disabled="viewOnly"
                v-on:input="filterReports"
              >
                <option
                  v-for="(option, index) in containers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Report Type">
              <b-select
                expanded
                name="reportType"
                v-model="localForm.report"
                placeholder="Please select"
                :disabled="viewOnly"
                v-on:input="setReportType"
              >
                <option
                  v-for="(option, index) in reports"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.report_type }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Report Definition" v-if="isCopy">
              <b-select
                expanded
                name="report"
                v-model="localForm.report_definition"
                placeholder="Please select"
                required
              >
                <option
                  v-for="(option, index) in report_definitions"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field>
              <b-checkbox
                label="Follow up Report"
                v-if="isCopy"
                v-model="localForm.is_follow_up"
                v-on:input="setFollowUpReports"
                :disabled="!localForm.report_definition"
              >
                Follow Up Report Definition
              </b-checkbox>
            </b-field>
            <b-field
              label="Follow Up Report Type"
              v-if="isCopy && localForm.is_follow_up"
            >
              <b-select
                expanded
                name="followUpReportType"
                v-model="localForm.follow_up_report"
                placeholder="Please select"
                :disabled="!localForm.report_definition"
              >
                <option
                  v-for="(option, index) in followUpDorpdown"
                  :value="option"
                  :key="index"
                >
                  {{ option.report_type }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Valid From">
              <b-datepicker
                class="analytics-date-picker"
                v-model="localForm.valid_from"
                required
                icon="calendar-today"
                trap-focus
                :date-formatter="dateFormatter"
                v-on:input="checkValues"
              >
              </b-datepicker>
            </b-field>
            <b-field label="Valid To">
              <b-datepicker
                class="analytics-date-picker"
                v-model="localForm.valid_to"
                required
                icon="calendar-today"
                trap-focus
                :date-formatter="dateFormatter"
                v-on:input="checkValues"
              >
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="!viewOnly">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
          :disabled="disableOKButton"
        >
          OK
        </b-button>
        <b-button slot="right" type="is-normal" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import RulesManagerService from "../../services/RulesManagerService";
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
// @group Dashboard
export default {
  name: "AddReportDefinition",
  mixins: [UtilityMixin, scopeMixin],
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    viewOnly: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isCopy: {
      type: Boolean,
      default: false
    },
    form: {
      default: () => {
        return {
          id: "",
          country: "",
          scheme: "",
          stream: "",
          report: "",
          report_type: "",
          report_definition: "",
          is_follow_up: false,
          follow_up_report: "",
          valid_from: null,
          valid_to: null
        };
      }
    },
    accountId: {
      type: Number,
      default: -1
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    const localForm = { ...this.form };
    if (typeof localForm.valid_from === "string" && localForm.valid_from) {
      localForm.valid_from = new Date(localForm.valid_from);
    }
    if (typeof localForm.valid_to === "string" && localForm.valid_to) {
      localForm.valid_to = new Date(localForm.valid_to);
    }
    if (typeof localForm.is_tabular_report === "undefined") {
      localForm.is_tabular_report = false;
    }
    return {
      reportingTrackerService: new ReportingTrackerDataService(),
      RulesManagerService: new RulesManagerService(),
      isModalActive: false,
      loading: "",
      reports: [],
      localForm,
      followUpDorpdown: [],
      report_definitions: [],
      disableOKButton: false
    };
  },
  mounted() {
    this.checkValues();
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchReportingTrackerData();
  },
  methods: {
    fetchReportingTrackerData() {
      this.reportingTrackerService.getAllReports().subscribe(
        response => {
          this.reports = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    setFollowUpReports(value) {
      if (!value) {
        this.localForm.follow_up_report = null;
        this.followUpDorpdown = [];
      } else {
        this.reportingTrackerService
          .getReportBySchemeStream(
            this.localForm.scheme,
            this.localForm.stream,
            this.localForm.report,
            true
          )
          .subscribe(
            response => {
              this.followUpDorpdown = response;
            },
            e => {
              console.log(e);
            }
          );
      }
      this.checkValues();
    },
    setReportType(reportId) {
      // Reset follow up fields when report type changes
      this.localForm = {
        ...this.localForm,
        is_follow_up: false,
        follow_up_report: null
      };
      this.report = this.reports.filter(e => e.id == reportId);
      this.localForm.report_type = this.report
        ? this.report[0].report_type
        : "";
      if (this.isCopy) {
        this.RulesManagerService.getFilterReportDefition(
          this.localForm.country,
          this.localForm.scheme,
          this.localForm.stream,
          this.localForm.is_follow_up,
          reportId
        ).subscribe(
          response => {
            this.report_definitions = response;
          },
          e => {
            console.log(e);
          }
        );
      }
      this.checkValues();
    },
    filterScheme(countryId) {
      this.country = this.countries.filter(e => e.id == countryId);
      this.localForm.country_code = this.country ? this.country[0].code : "";
      this.localForm.country_name = this.country ? this.country[0].name : "";
      this.localForm.scheme = null;
      this.localForm.stream = null;
      this.localForm.report = null;
      if (countryId) {
        this.schemeDataService.getByCountry(countryId).subscribe(
          response => {
            this.schemes = response;
          },
          e => {
            console.log(e);
          }
        );
      }
      this.checkValues();
    },
    filterStream(schemeId) {
      this.scheme = this.schemes.filter(e => e.id == schemeId);
      this.localForm.scheme_name = this.scheme ? this.scheme[0].name : "";
      this.localForm.stream = null;
      this.localForm.report = null;
      if (schemeId) {
        this.schemeDataService.get(schemeId).subscribe(
          response => {
            this.containers = response["container"];
            this.containers = this.containers.filter(e => e.name !== "General");
          },
          e => {
            console.log(e);
          }
        );
      }
      this.checkValues();
    },

    filterReports() {
      this.localForm.report = null;
      this.stream = this.containers.filter(e => e.id == this.localForm.stream);
      this.localForm.stream_name = this.stream ? this.stream[0].name : "";
      if (this.localForm.stream) {
        this.reportingTrackerService
          .getReportBySchemeStream(
            this.localForm.scheme,
            this.localForm.stream,
            0,
            true
          )
          .subscribe(
            response => {
              this.reports = response;
            },
            e => {
              console.log(e);
            }
          );
      }
      this.checkValues();
    },
    cancel() {
      this.localForm = { ...this.form };
      if (
        typeof this.localForm.valid_from === "string" &&
        this.localForm.valid_from
      ) {
        this.localForm.valid_from = new Date(this.localForm.valid_from);
      }
      if (
        typeof this.localForm.valid_to === "string" &&
        this.localForm.valid_to
      ) {
        this.localForm.valid_to = new Date(this.localForm.valid_to);
      }
      this.$emit("cancel");
    },

    submit() {
      const emitForm = {
        ...this.localForm,
        valid_from:
          this.localForm.valid_from instanceof Date
            ? this.dateFormatter(this.localForm.valid_from)
            : this.localForm.valid_from,
        valid_to:
          this.localForm.valid_to instanceof Date
            ? this.dateFormatter(this.localForm.valid_to)
            : this.localForm.valid_to
      };
      this.$emit("confirm", emitForm);
    },

    checkValues() {
      // Check required fields
      const hasRequired =
        this.localForm.country > 0 &&
        this.localForm.scheme > 0 &&
        this.localForm.stream > 0 &&
        this.localForm.report > 0 &&
        this.localForm.valid_from != undefined &&
        this.localForm.valid_to != undefined;

      // If required fields are missing, disable OK
      if (!hasRequired) {
        this.disableOKButton = true;
        return;
      }

      // If follow up is checked but no follow_up_report, disable OK
      if (this.localForm.is_follow_up && !this.localForm.follow_up_report) {
        this.disableOKButton = true;
        return;
      }

      // If isCopy, require report_definition
      if (this.isCopy && !(this.localForm.report_definition > 0)) {
        this.disableOKButton = true;
        return;
      }

      // Otherwise, enable OK
      this.disableOKButton = false;
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.localForm = { ...newVal };
        if (
          typeof this.localForm.valid_from === "string" &&
          this.localForm.valid_from
        ) {
          this.localForm.valid_from = new Date(this.localForm.valid_from);
        }
        if (
          typeof this.localForm.valid_to === "string" &&
          this.localForm.valid_to
        ) {
          this.localForm.valid_to = new Date(this.localForm.valid_to);
        }
      },
      deep: true
    },
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
        this.disableOKButton = true;
      }
    }
  }
};
</script>
